export const data = [
  {
    image: "/Images/others/FindMyWay.png",
    name: "Find My Way",
    type: "Web Application/ React",
    url: "find-my-way",
    fullImage: null,
    tecs: [
      "HTML5",
      "CSS",
      "Javascript",
      "Jsx",
      "npm",
      "Fabric.js",
      "React.js",
      "Canvas API",
      "REST API",
      "Node.js",
    ],
    giturl: "https://au.fmw.app.com/",
    about:
      "FindMyWay is an indoor navigation web application that helps users locate the shortest path between two points within complex buildings like malls, hospitals, and campuses. Built with React.js, Fabric.js, and PHP, the system features an interactive canvas-based map with pan, zoom, and rotation controls. It uses Dijkstra's algorithm to calculate optimal routes, including multi-floor paths by comparing different modes of transport such as elevators, escalators, and stairs. Admins can manage floor plans, add pins, draw paths, and define regions, while users benefit from a smooth, real-time map experience that simplifies indoor navigation.",
  },
  {
    image: "/Images/others/itype4home.png",
    name: "Itype 4 home",
    type: "Web Application/ React",
    url: "itype-4-home",
    fullImage: null,
    tecs: [
      "HTML5",
      "CSS",
      "Javascript",
      "Jsx",
      "npm",
      "React.js",
      "REST API",
      "Node.js",
    ],
    giturl: null,
    about:
      "ITYPE 4 Home is an interactive web platform designed to help students improve typing speed and accuracy through gamified keyboard-centric exercises. Built with React.js and Fabric.js, it features a multi-portal system where students engage in real-time typing games while parents monitor progress through a dedicated dashboard. The system tracks metrics like words per minute and accuracy, provides performance analytics, and ensures a seamless, responsive experience across devices, enabling families to support learning from home.",
  },
  {
    image: "/Images/go-organic/go-organic-banner.png",
    name: "Go organic",
    type: "Website / woo-commerce",
    url: "go-organic",
    fullImage: "/Images/go-organic/go-organic-au.png",
    tecs: [
      "HTML5",
      "CSS",
      "Javascript",
      "php",
      "jquery",
      "Wordpress",
      "woo-commerce",
    ],
    giturl: "https://go-organic.com.au/",
    about:
      "Go-Organic started from humble beginnings as a small fruit and veg co-op by a couple who had a passion for organic produce.",
  },
  {
    image: "/Images/equario8/Equario8-Home-Page.png",
    name: "equario8",
    type: "Website / wordpress",
    url: "equario8",
    fullImage: "/Images/equario8/Equario8-Home-Page-full.png",
    tecs: ["HTML5", "CSS", "Javascript", "php", "jquery", "Wordpress", ""],
    giturl: "https://equarius8.com/",
    about:
      "Equario8 mission is to help empower Rising Stars, Women, LGBTQ+ and Ethnically Diverse Talent to unlock their leadership potential, recognise and harness their unique gifts, gain clarity to focus on what matters most and achieve success on their terms.They aim to help empower individuals to liberate themselves from old paradigms and limiting beliefs that no longer serve them and to live authentically and embrace their true selves.",
  },
  {
    image: "/Images/ajfan/ajfan-home.png",
    name: "Ajfan Store",
    type: "Ecommerce / shopify",
    url: "ajfan",
    fullImage: "/Images/ajfan/ajfan-fullpage.png",
    tecs: ["HTML5", "CSS", "Javascript", "liquid", "jquery", "Shopify", "Ajax"],
    giturl: "https://ajfan.store/",
    about:
      "Ajfan Store is a luxury dry-fruit brand with over 150 outlets across India. Built using Shopify, the platform includes bundle products, customer reviews, wishlist functionality, and multiple payment gateways.",
  },
  {
    image: "/Images/drashik/Dr-Ashik-Sainu-home-Dr-Ashik-Sainu-home-page.png",
    name: "Dr Ashik Sainu",
    type: "Website / wordpress",
    url: "drashik",
    fullImage: "/Images/drashik/Dr-Ashik-Sainu-home-Dr-Ashik-Sainu.png",
    giturl: "https://drashiksainu.org/",
    about: "",
  },
  {
    image: "/Images/soleilproduction/Soleilproductions-home.png",
    name: "Soleilproductions",
    type: "Website / wordpress",
    url: "soleilproductions",
    fullImage: "/Images/soleilproduction/Soleilproductions.png",
    tecs: ["HTML5", "CSS", "Javascript", "liquid", "jquery", "Shopify", ""],
    about:
      "Soleil Productions LLC is a video production team that creates engaging, creative and heartfelt videos for businesses and organizations of all sizes. Led by CEO and founder Soleil Jaan, Soleil Productions team has a passion for telling stories that connect with people on an emotional level. ",
    giturl: "https://beta.chkdemo.com/Soleilproductions/",
  },
];

export const majorworks = [
  {
    image: "/Images/others/FindMyWay.png",
    name: "Find My Way",
    type: "Web Application/ React",
    url: "find-my-way",
    fullImage: null,
    tecs: [
      "HTML5",
      "CSS",
      "Javascript",
      "Jsx",
      "npm",
      "Fabric.js",
      "React.js",
      "Canvas API",
      "REST API",
      "Node.js",
    ],
    giturl: "https://au.fmw.app.com/",
    about:
      "FindMyWay is an indoor navigation web application that helps users locate the shortest path between two points within complex buildings like malls, hospitals, and campuses. Built with React.js, Fabric.js, and PHP, the system features an interactive canvas-based map with pan, zoom, and rotation controls. It uses Dijkstra's algorithm to calculate optimal routes, including multi-floor paths by comparing different modes of transport such as elevators, escalators, and stairs. Admins can manage floor plans, add pins, draw paths, and define regions, while users benefit from a smooth, real-time map experience that simplifies indoor navigation.",
  },
  {
    image: "/Images/others/itype4home.png",
    name: "Itype 4 home",
    type: "Web Application/ React",
    url: "itype-4-home",
    fullImage: null,
    tecs: [
      "HTML5",
      "CSS",
      "Javascript",
      "Jsx",
      "npm",
      "React.js",
      "REST API",
      "Node.js",
    ],
    giturl: null,
    about:
      "ITYPE 4 Home is an interactive web platform designed to help students improve typing speed and accuracy through gamified keyboard-centric exercises. Built with React.js and Fabric.js, it features a multi-portal system where students engage in real-time typing games while parents monitor progress through a dedicated dashboard. The system tracks metrics like words per minute and accuracy, provides performance analytics, and ensures a seamless, responsive experience across devices, enabling families to support learning from home.",
  },
  {
    image: "/Images/equario8/Equario8-Home-Page.png",
    name: "equario8",
    type: "Website / Wordpress",
    url: "equario8",
    fullImage: "/Images/equario8/Equario8-Home-Page-full.png",
    tecs: ["HTML5", "CSS", "Javascript", "php", "jquery", "Wordpress", ""],
    giturl: "https://equarius8.com/",
    about:
      "Equario8 mission is to help empower Rising Stars, Women, LGBTQ+ and Ethnically Diverse Talent to unlock their leadership potential, recognise and harness their unique gifts, gain clarity to focus on what matters most and achieve success on their terms.They aim to help empower individuals to liberate themselves from old paradigms and limiting beliefs that no longer serve them and to live authentically and embrace their true selves.",
  },
  {
    image: "/Images/go-organic/go-organic-banner.png",
    name: "Go organic",
    type: "Website / Woo-commerce",
    url: "go-organic",
    fullImage: "/Images/go-organic/go-organic-au.png",
    tecs: [
      "HTML5",
      "CSS",
      "Javascript",
      "php",
      "jquery",
      "Wordpress",
      "woo-commerce",
    ],
    giturl: "https://go-organic.com.au/",
    about:
      "Go-Organic started from humble beginnings as a small fruit and veg co-op by a couple who had a passion for organic produce.",
  },
  {
    image: "/Images/ajfan/ajfan-home.png",
    name: "Ajfan Store",
    type: "Ecommerce / Shopify",
    url: "ajfan",
    fullImage: "/Images/ajfan/ajfan-fullpage.png",
    tecs: ["HTML5", "CSS", "JavaScript", "Liquid", "jQuery", "Shopify", "Ajax"],
    giturl: "https://ajfan.store/",
    about:
      "Ajfan Store is a luxury dry-fruit brand with over 150 outlets across India. The Shopify-based e-commerce platform includes bundle products, customer reviews, wishlist functionality, and multiple payment gateways.",
  },
  {
    image: "/Images/soleilproduction/Soleilproductions-home.png",
    name: "Soleil Productions",
    type: "Website / WordPress",
    url: "soleilproductions",
    fullImage: "/Images/soleilproduction/Soleilproductions.png",
    tecs: ["HTML5", "CSS", "JavaScript", "PHP", "jQuery", "WordPress"],
    giturl: "https://beta.chkdemo.com/Soleilproductions/",
    about:
      "Soleil Productions LLC is a video production company that creates engaging and heartfelt videos for businesses of all sizes. The WordPress site showcases their portfolio and positions CEO Soleil Jaan's story-driven brand effectively.",
  },
];
